import { render, staticRenderFns } from "./RequestPage.vue?vue&type=template&id=46edcdb0&"
import script from "./RequestPage.vue?vue&type=script&lang=js&"
export * from "./RequestPage.vue?vue&type=script&lang=js&"
import style0 from "./RequestPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports